import { render, staticRenderFns } from "./CDisasters.vue?vue&type=template&id=3b571ee2&scoped=true"
import script from "./CDisasters.vue?vue&type=script&lang=js"
export * from "./CDisasters.vue?vue&type=script&lang=js"
import style0 from "./CDisasters.vue?vue&type=style&index=0&id=3b571ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b571ee2",
  null
  
)

export default component.exports